import { types } from 'mobx-state-tree';

const PendingActionsStore = types
	.model('PendingActionsStore', {
		_map: types.map(types.boolean),
	})
	.views(self => ({
		isPending(name) {
			return !!self._map.get(name);
		},
	}))
	.actions(self => ({
		setPending(name) {
			if (self.isPending(name)) throw new Error('Already executing: ' + name);
			self._map.set(name, true);
		},
		clearPending(name) {
			if (!self.isPending(name)) throw new Error('Not executing: ' + name);
			self._map.delete(name);
		},
	}));

export const pendingActionsStore = PendingActionsStore.create();
